<template>
    <hts-modal
        v-if="checkPermission(layoutPermissions.route.delete)"
        :show="visible"
        :title="$t('labels.routeDelete')"
        type="confirm"
        :content="$t('labels.routeConfirmDelete')"
        :loading="loading"
        @close="close"
        @confirm="() => handleDelete()" />
</template>
<script setup lang="ts">
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
const { $formatters } = useNuxtApp()

const emits = defineEmits(['refreshTables'])
const visible = ref(false)
const loading = ref(false)
const id = ref('')

const open = (idValue: string) => {
  id.value = idValue
  visible.value = true
}

const close = () => {
  loading.value = false
  visible.value = false
}

const handleDelete = () => {
  const api = $url.route.route.deletes
  loading.value = true
  $api(api, { body: { ids: [id.value || null] } })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        close()
        loading.value = false
        process.client && $toast().success('Xoá tuyến thành công')
        emits('refreshTables')
      } else {
        loading.value = false
      }
    })
    .catch(() => {
      loading.value = false
    })
}

defineExpose({ open })
</script>
